var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopDiagonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a5b3aa2f-7af6-4365-9ad1-c81112abccb4",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 771.86 639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f939a22c-ae95-48a4-88f3-32e2bc3e94fb{fill:#fff;}.f6023f63-e6d2-49cb-9153-d17bfd7a951c{fill:#c76a3c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f939a22c-ae95-48a4-88f3-32e2bc3e94fb",
    d: "M130,0H754V639H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f6023f63-e6d2-49cb-9153-d17bfd7a951c",
    d: "M147.86,0h624V639h-754Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopDiagonal);
export default __webpack_public_path__ + "static/media/desktop-diagonal.9720e4d07794ced5e140367d0906c906.svg";
export { ForwardRef as ReactComponent };